import { render, staticRenderFns } from "./Official_Duration.vue?vue&type=template&id=f2aa4f5c&scoped=true"
import script from "./Official_Duration.vue?vue&type=script&lang=js"
export * from "./Official_Duration.vue?vue&type=script&lang=js"
import style0 from "./Official_Duration.vue?vue&type=style&index=0&id=f2aa4f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2aa4f5c",
  null
  
)

export default component.exports